import { changePasswordStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

changePasswordStyles.userInformationTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        color: ${getColor("secondary")};
        font-weight: ${TYPOGRAPHY.weight.baseBold};
        margin-bottom: 7px;
    `,
};

changePasswordStyles.passwordGridContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        max-width: 300px;
                        margin: 0;
                    `,
                ],
                "min",
            )}
    `,
    gap: 10,
};
